// Imports
import { getContrast, setLightness, setSaturation } from 'polished';
import styled from 'styled-components/macro';
import theme from '../../../shareables/theme';


// Define the accepted props
interface Props {
	color: 'success' | 'danger' | 'yellow' | 'info';
}


// Styled component
const Notice = styled.div<Props>`
	border-radius: 0.1875rem;
	box-shadow: 0 0.125rem 0.25rem hsla(0, 0%, 0%, 0.1);
	padding: 1.25rem;
	line-height: 1.25;
	overflow-wrap: break-word;
	
	background-color: ${(props) => theme.colors[props.color]};
	color: ${(props) =>
		getContrast(theme.colors[props.color], 'hsl(0, 0%, 100%)') > 1.9
			? 'hsl(0, 0%, 100%)'
			: setSaturation(0.2, setLightness(0.3, theme.colors[props.color]))};
	
	&:not(:last-child) {
		margin-bottom: 1.5rem;
	}
	
	p:not(:last-child) {
		margin-bottom: 1em;
	}
	
	a {
		color: inherit;
		text-decoration: underline;
		
		&:hover {
			color: inherit;
			text-decoration: none;
		}
	}
`;

export default Notice;
